<div class="upload-control" [ngClass]="{'disabled': formControl?.disabled}">
  <input #fileInput type="file" [accept]="accept" hidden [disabled]="formControl?.disabled"
    (change)="handleFileInput($event)" />

  <!-- Upload Button -->
  <div class="file-upload-btn" *ngIf="!(formControlValue?.file || formControlValue?.readableUrl)" (click)="triggerUpload()">
    <span class="file-upload-btn-placeholder">NO FILE SELECTED</span>
    <span class="upload-file-block">Upload File</span>
  </div>

  <!-- Non-Image File Placeholder -->
  <ng-container *ngIf="formControlValue">
    @if(formControlValue.readableUrl && (isImageFile(formControlValue?.file) || isImageUrl(formControlValue?.readableUrl) )){
    <div class="file-preview-image" (click)="triggerUpload()">
      <img [src]="formControlValue?.readableUrl" alt="File preview" />
      <span class="replace-image-btn" *ngIf="!isInPreviewMode">REPLACE IMAGE</span>
    </div>
    }

    @else if(isPdfFile(formControlValue?.file) || isPdfUrl(formControlValue?.readableUrl) ) {
    <div class="file-preview-pdf" (click)="triggerUpload()">
      <pdf-viewer [src]="formControlValue?.readableUrl" [render-text]="true" 
        [original-size]="false" style="width: 250px; height: 350px"></pdf-viewer>
      <span class="replace-image-btn" *ngIf="!isInPreviewMode">REPLACE FILE</span>
    </div>
    }

    @else {
    <div class="uploaded-img-placeholder" *ngIf="formControlValue?.file && !isImageFile(formControlValue?.file)">
      <span class="file-name">{{ formControlValue?.file.name }}</span>
      <span class="file-uploaded" *ngIf="isInPreviewMode">Uploaded File</span>
      <i role="button" class="material-symbols-outlined" *ngIf="!isInPreviewMode" (click)="clearFile()">
        close
      </i>
    </div>

    }




    <!-- Image Preview -->

  </ng-container>

</div>